export const getItemClass = ({ disabled, type }: any) => {
  const toReturn: string[] = [];

  if (disabled) {
    toReturn.push('disabled');
  }

  switch (type) {
    default:
    case 'default':
      toReturn.push('default');
      break;
    case 'warning':
      toReturn.push('warning');
      break;
    case 'danger':
      toReturn.push('danger');
      break;
  }

  return toReturn;
};

export const getDataTestId = (title: string) => `menu-item-${title.replace(/\s+/g, '-').toLowerCase()}`;
